import { accTypeOptions } from "@/common/const/accountTypes/accountTypes.const";
import { FormFieldsStrategyType } from "../../types";
import { currencyOptions } from "@/common/const";

const companyFormStrategy: FormFieldsStrategyType[] = [
  {
    name: "companyName",
    label: "Company Name",
    readonly: false,
    required: true,
    inputType: "text",
    errorMessage: "This field is required",
  },
  {
    name: "id",
    label: "Company id",
    readonly: true,
    required: false,
    inputType: "text",
  },
  {
    name: "accountType",
    label: "Account Type",
    readonly: false,
    required: false,
    inputType: "select",
    options: accTypeOptions,
  },
  {
    name: "registered_address",
    label: "Registered Address",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    name: "billing_address",
    label: "Billing Address",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    name: "country",
    label: "Location (Country)",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    name: "status",
    label: "Account Status",
    readonly: true,
    required: false,
    inputType: "text",
    inputClassElement: "capitalize",
  },
  {
    name: "createdAt",
    label: "Date joined",
    readonly: true,
    required: false,
    inputType: "text",
    isTime: true,
  },
  {
    name: "uploadedAt",
    label: "Last Active",
    readonly: true,
    required: false,
    inputType: "text",
    isTime: true,
  },
  {
    label: "Account Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    options: currencyOptions,
  },
  {
    label: "NDA",
    name: "nda",
    readonly: false,
    required: false,
    inputType: "select",
    options: [
      { value: "true", label: "Signed" },
      { value: "false", label: "Pending" },
      { value: "null", label: "No agreement" },
    ],
  },
  {
    label: "MSA",
    name: "msa",
    readonly: false,
    required: false,
    inputType: "select",
    options: [
      { value: "true", label: "Signed" },
      { value: "false", label: "Pending" },
      { value: "null", label: "No agreement" },
    ],
  },
  {
    label: "Salesforce ID",
    name: "salesforceId",
    required: false,
    readonly: true,
    inputType: "text",
  },
  {
    label: "Customer Website",
    name: "website",
    readonly: false,
    required: false,
    inputType: "text",
    labelClassName: "font-light",
  },
];

const companyCreateNewStrategy: FormFieldsStrategyType[] = [
  {
    name: "companyName",
    label: "Company Name",
    readonly: false,
    required: true,
    inputType: "text",
    errorMessage: "This field is required",
  },

  {
    name: "accountType",
    label: "Account Type",
    readonly: false,
    required: false,
    inputType: "select",
    defaultValue: "msp",
    options: accTypeOptions,
  },
  {
    name: "registered_address",
    label: "Registered Address",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    name: "billing_address",
    label: "Billing Address",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    name: "country",
    label: "Location (Country)",
    readonly: false,
    required: true,
    inputType: "text",
  },

  {
    label: "Account Currency",
    name: "currency",
    readonly: false,
    required: false,
    inputType: "select",
    defaultValue: "USD",
    options: currencyOptions,
  },
  {
    label: "Contract Status NDA",
    name: "nda",
    readonly: false,
    required: false,
    inputType: "select",
    defaultValue: "null",
    options: [
      { label: "Signed", value: "true" },
      { label: "Pending", value: "false" },
      { label: "No agreement", value: "null" },
    ],
  },
  {
    label: "Contract Status MSA",
    name: "msa",
    readonly: false,
    required: false,
    inputType: "select",
    defaultValue: "null",
    options: [
      { label: "Signed", value: "true" },
      { label: "Pending", value: "false" },
      { label: "No agreement", value: "null" },
    ],
  },

  {
    label: "Website",
    name: "website",
    readonly: false,
    required: false,
    inputType: "text",
  },
  {
    label: "Salesforce ID",
    name: "salesforceId",
    required: false,
    inputType: "text",
  },
];
export { companyFormStrategy, companyCreateNewStrategy };
